<div id="dashboard-sidebar" class="box-shadow-right" [ngClass]="{ active: (isOpenSidebar$ | async) }">
    <div id="dashboard-sidebar-header">
        <a [routerLink]="['/']">
            <img
                class="logo"
                [src]="'./assets/images/bank-pekao-logo.png'"
                alt="{{ 'layout.logoAlternateText' | translate }}" />
        </a>
    </div>
    <div id="dashboard-sidebar-content">
        <app-dashboard-layout-sidebar-client [representative]="currentRepresentative$ | async">
        </app-dashboard-layout-sidebar-client>
        <ul>
            <li *ngFor="let menu of navigation">
                <a
                    class="t-m t-15"
                    [routerLink]="menu.link"
                    [routerLinkActiveOptions]="{ exact: menu.exact }"
                    (click)="navigationClick()"
                    routerLinkActive="active">
                    <svg-icon
                        [src]="'assets/icons/' + menu.icon + '.svg'"
                        [svgStyle]="{ 'width.px': 24, 'height.px': 24 }">
                    </svg-icon>
                    <span>{{ 'layout.navbar.links.' + menu.text | translate }}</span>
                </a>
            </li>
        </ul>
    </div>
    <div id="dashboard-sidebar-footer" class="d-flex justify-content-between align-items-center">
        <span class="t-12">{{ version$ | async }}</span>
        <button
            [ngClass]="{ 'd-none': (isOpenSidebar$ | async) === false }"
            [full]="true"
            (click)="toggleSidebar()"
            appButtonIcon
            color="secondary"
            iconSize="xsmall">
            <svg-icon src="assets/icons/ChevronLeft.svg"></svg-icon>
        </button>
    </div>
</div>
